class Gender {
    constructor(name) {
        this.name = name;
    }
}   

const genders = [
    new Gender('MALE'),
    new Gender('FEMALE')
];      

export { Gender, genders };